import { useMemo, useCallback } from 'react'
import { first } from 'lodash'

import { UserProfileType } from '@monorepo/interfaces'
import { getUserProfileSchema } from '@monorepo/validations'
import { useCompany } from '../App'
import { useUser } from './useUser'

export function useUserProfileForm() {
  const { user, registerUserHandler, updateProfileHandler } = useUser()
  const { salesPoint } = useCompany()

  const initialValues: UserProfileType = useMemo(
    () => ({
      lastName: user.profile.lastName || '',
      firstName: user.profile.firstName || '',
      middleName: user.profile.middleName || '',
      email: user.profile.email || '',
      phone: user.profile.phone || '',
      address: user.profile.address || '',
      markup: user.profile.markup || 0,
      isWholesale: user.profile.isWholesale || false,
      ...(user.isGuest && {
        office: user.profile.office || first(salesPoint),
        plainPassword: {
          first: '',
          second: '',
        },
      }),
    }),
    [
      salesPoint,
      user.isGuest,
      user.profile.address,
      user.profile.email,
      user.profile.firstName,
      user.profile.isWholesale,
      user.profile.lastName,
      user.profile.markup,
      user.profile.middleName,
      user.profile.office,
      user.profile.phone,
    ]
  )

  const submitHandler = useCallback(
    (values: UserProfileType) => {
      if (user.isGuest) {
        return registerUserHandler(values)
      } else {
        return updateProfileHandler(values)
      }
    },
    [registerUserHandler, updateProfileHandler, user.isGuest]
  )
  // const validationSchema = useMemo(() => getUserProfileSchema({ user }), [user])
  const validationSchema = getUserProfileSchema({ user })

  return { validationSchema, initialValues, submitHandler }
}
